export default "__VITE_ASSET__Hgm55Lon__"